import React, { useState } from 'react';
import { useAulaEditorContext } from '../../EditorContext';
import { WithBottomBorder } from './DropTarget.styled';

/**
 * Define your component's props with a type (or interface)
 */
export type DropTargetProps = {
  onDrop?: React.DragEventHandler<HTMLDivElement>;
};

/**
 * DropTarget Component
 *
 */
export const DropTarget: React.FunctionComponent<
  DropTargetProps & React.HTMLAttributes<HTMLDivElement>
> = ({ children, onDrop, ...attributes }) => {
  const [dragIndex, setDragIndex] = useState(0);
  const { draggingElement, setDraggingElement } = useAulaEditorContext();

  return (
    <div
      {...attributes}
      onDragEnter={(e) => {
        /**
         * The custom d&d logic only applies to dropping files and blocks
         * via the drag handle
         */
        if (draggingElement || e.dataTransfer.types.includes('Files')) {
          e.preventDefault();
          setDragIndex(dragIndex + 1);
        }
      }}
      onDrop={(e) => {
        if (draggingElement || e.dataTransfer.types.includes('Files')) {
          e.preventDefault();
          setDragIndex(0);
          if (onDrop) {
            onDrop(e);
          }
        }
        setDraggingElement(null);
      }}
      onDragOver={(e) => {
        if (draggingElement || e.dataTransfer.types.includes('Files')) {
          e.preventDefault();
        }
      }}
      onDragLeave={(e) => {
        if (draggingElement || e.dataTransfer.types.includes('Files')) {
          e.preventDefault();
          setDragIndex(dragIndex - 1);
        }
      }}
      onMouseLeave={() => {
        setDragIndex(0);
      }}
      style={{
        position: 'relative',
      }}
    >
      {/**
       * COMPAT: Uneditable dom elements among contentEditable content must be unreachable via arrow keys (when moving up & down) and unfocusable.
       * To achieve this in Chromium it must
       * - use contentEditable={false}
       * - have at least one child (even though it's otherwise semantically and functionally meaningless)
       * - use css rule - `visiblity: false` to not interfere with selection input events
       */}
      <WithBottomBorder
        active={dragIndex > 0}
        contentEditable={false}
        tabIndex={-1}
      >
        <div />
      </WithBottomBorder>
      {children}
    </div>
  );
};
